var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActivityDialog',{ref:"ActivityDialog",attrs:{"width":"548px"}},[_c('template',{slot:"activityDialog-body"},[_c('Carousel',{attrs:{"carousel-type":"移动端","height":"663px"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }